import React, { useContext, useEffect, useState } from 'react'
import Table from '../../Components/Insights/Table/Table'
import Filter from '../../Components/Catalog/Filter/Filter'
import PageHeader from '../../Components/Layout/PageHeader/PageHeader';
import CloseIcon from '../../Assets/Images/CloseIcon.svg';
import SectionHeader from '../../Components/Layout/SectionHeader/SectionHeader';
import Sentiments from '../../Components/Insights/Sentiments/Sentiments'
import DailyWork from '../../Components/Insights/DailyWork/DailyWork';
import Engagements from '../../Components/Insights/Engagements/Engagements';
import Passions from '../../Components/Insights/Passions/Passions';
import { CatalogContext } from '../../Context/CatalogContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function Insights() {

  const {
    handleCheckboxChange,
    checkboxStates,
    totalCount,
    filteredData,
    dataFilters,
    filters,
    clearFilters,
    gender,
    setGender,
    setFilteredMaxAge,
    setFilteredMinAge,
    filteredMinAge,
    filteredMaxAge,
    removeFilter,
  } = useContext(CatalogContext);

  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const [filterBoxOpened, setFilterBoxOpened] = useState(false);
  const [tabs, setTabs] = useState([{ label: "Daily Work", isActive: true }, { label: "Sentiments", isActive: false }, { label: "Church Engagement", isActive: false }, { label: "Passions", isActive: false },]);
  const [tableTabs, setTableTabs] = useState([{ label: "Table View 1", isActive: true }, { label: "Table View 2", isActive: false }, { label: "Table View 3", isActive: false },]);
  const [tableViewOpen, setTableViewOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Daily Work");
  const [activeTableTab, setActiveTableTab] = useState("Table View 1");

  useEffect(() => {
    clearFilters();
  }, [])
  useEffect(() => {
    let tab = searchParams.get('tab');
    if(tab) {
      if(tab === 'daily-work'){
        setInsightsTab(0);
      }
      else if(tab === 'sentiments'){
        setInsightsTab(1);
      }
      else if(tab === 'church-engagements'){
        setInsightsTab(2);
      }
      else if(tab === 'passions'){
        setInsightsTab(3);
      }
      else{
        navigate('/insights?tab=daily-work')
      }
    }
  }, [searchParams.get("tab")])

  const handleTabClick = (index) => {
    switch(index) {
      case 0: navigate('/insights?tab=daily-work'); break;
      case 1: navigate('/insights?tab=sentiments'); break;
      case 2: navigate('/insights?tab=church-engagements'); break;
      case 3: navigate('/insights?tab=passions'); break;
      default: navigate('/insights?tab=daily-work');
    }
  }

  const setInsightsTab = (index) => {
    setActiveTab(tabs[index].label);
    setTabs((prevTabs) =>
      prevTabs.map((tab, i) => ({
        ...tab,
        isActive: i === index
      }))
    );
  };
  const handleTableTabClick = (index) => {
    setActiveTableTab(tableTabs[index].label);
    setTableTabs((prevTabs) =>
      prevTabs.map((tab, i) => ({
        ...tab,
        isActive: i === index
      }))
    );
  };

  function handleClose() {
    setFilterBoxOpened(false);
  }
  function handleOpen() {
    setFilterBoxOpened(true);
  }
  const goBack = () => {
    setTableViewOpen(false);
  }
  return (
    <div className='insights'>
      {tableViewOpen ?
        <>
          <PageHeader handleBack={goBack} currentPage={activeTableTab} />
          <SectionHeader tabs={tableTabs} handleTabClick={handleTableTabClick} />
          <div className='insights-table-page'>
            <Filter onClose={handleClose} handleOpen={handleOpen} filterBoxOpened={filterBoxOpened} handleCheckboxChange={handleCheckboxChange} checkboxStates={checkboxStates} total={totalCount} count={filteredData?.length || 0} dataFilters={dataFilters} filtersApplied={filters.length} clearFilters={clearFilters} gender={gender} setGender={setGender} setFilteredMaxAge={setFilteredMaxAge} setFilteredMinAge={setFilteredMinAge} filteredMinAge={filteredMinAge} filteredMaxAge={filteredMaxAge} />
            <div className='insights-right'>
              <div className="insights-content">
                {filters.length > 0 && <div className='filters-container'>
                  {filters.map((filter, index) =>
                    <div className='filter' key={index}>
                      <p>{filter}</p>
                      <img src={CloseIcon} alt="close icon" width={12} height={12} onClick={() => removeFilter(filter)} />
                    </div>
                  )}
                </div>}
                <Table />
              </div>
            </div>
          </div>
        </>
        :
        <>
          <PageHeader currentPage={activeTab} />
          <SectionHeader tabs={tabs} handleTabClick={handleTabClick} ß />
          <div className='insights-inner-page'>
            {
              tabs.map((tab, i) => {
                if (tab.label === "Sentiments" && tab.isActive) {
                  return (<div><Sentiments setTableViewOpen={setTableViewOpen} /></div>)
                }
                if (tab.label === "Daily Work" && tab.isActive) {
                  return (<div className='dailywork-container'><DailyWork setTableViewOpen={setTableViewOpen} /></div>)
                }
                if (tab.label === "Church Engagement" && tab.isActive) {
                  return (<div><Engagements /></div>)
                }
                if (tab.label === "Passions" && tab.isActive) {
                  return (<div ><Passions setTableViewOpen={setTableViewOpen} /></div>)
                }
              })
            }
          </div>
        </>
      }
    </div>
  )
}
